import KnowledgeTest from "./KnowledgeTest";

export default KnowledgeTest;
